import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { Easings } from '@picsart/design-system/foundation/easings';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';

const useStyles = createUseStyles(
  {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
    },
    // Secondary header - hidden on all screen sizes (main Header provides context)
    header: {
      display: 'none',
    },
    headerIcon: {
      display: 'none',
    },
    content: {
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      WebkitOverflowScrolling: 'touch',
      ...hideScrollbars,
      padding: Spacings.s16,
      paddingBottom: Spacings.s48, // Extra bottom padding for How It Works
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s12,
      // Small mobile padding
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        padding: Spacings.s12,
        paddingBottom: Spacings.s32, // Extra bottom padding for How It Works
        gap: Spacings.s8,
      },
    },
    uploadSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
    },
    footer: {
      padding: Spacings.s12,
      backgroundColor: BackgroundColors.base,
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        padding: Spacings.s8,
      },
    },
    // Skeleton loading styles
    '@keyframes shimmer': {
      '0%': {
        backgroundPosition: '-200% 0',
      },
      '100%': {
        backgroundPosition: '200% 0',
      },
    },
    skeleton: {
      background: `linear-gradient(90deg, ${BackgroundColors.tint1} 25%, ${BackgroundColors.tint2} 50%, ${BackgroundColors.tint1} 75%)`,
      backgroundSize: '200% 100%',
      animation: `$shimmer 1.5s ${Easings.easeInOut} infinite`,
      borderRadius: CornerRadius.r8,
    },
    skeletonPreview: {
      width: '100%',
      height: 140,
      borderRadius: CornerRadius.r12,
    },
    skeletonDescription: {
      width: '100%',
      height: 40,
      marginTop: Spacings.s8,
    },
    skeletonInput: {
      width: '100%',
      height: 120,
    },
    skeletonButton: {
      width: '100%',
      height: 48,
      borderRadius: CornerRadius.r8,
    },
  },
  { name: 'create-skeleton' }
);

export default useStyles;
